<div class="common-checkbox-list" [ngClass]="hostClasses">
  <div class="common-checkbox-list__title-row">
    <p class="common-checkbox-list__title c_500" *ngIf="titleKey">
      {{ titleKey | translate }}
    </p>
  </div>

  <div class="common-checkbox-list__options" [ngClass]="optionsClasses" [style.--munily-checkbox-list-columns]="columnsCount">
    <div
      class="common-checkbox-list__option"
      *ngFor="let opt of options; let i = index"
    >
      <app-common-checkbox
        [id]="'munily-checkbox-list-' + i"
        [name]="'munily-checkbox-list'"
        [labelKey]="opt.labelKey"
        [labelParams]="opt.labelParams"
        [type]="checkboxType"
        [disabled]="disabled || !!opt.disabled"
        [bulletAllowUnselect]="true"
        [ngModel]="isChecked(opt.value)"
        (change)="onOptionToggle(opt.value, $event)"
      ></app-common-checkbox>
    </div>
  </div>
</div>

